

export function mapGastoMetodo(row) {
  return {
    fecha: row.fecha,
    metodoPago: row.metodo_pago,
    categoria: row.categoria,
    clasificacion: row.clasificacion,
    cantidad: Number(row.cantidad_gastos),
    total: Number(row.total)
  };
}